import Regex from "./Regex";
export default Regex;
